import React from 'react';
import styled from 'styled-components';
import { Grid } from 'planoplan-ui-kit/core/helpers/grid';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { deviceDetected } from 'planoplan-ui-kit/core/device-detected';
import { getImage } from 'planoplan-ui-kit/core/get_image';
import { Points, paddingLevel, marginLevel } from '@styles';
import { useTranslations } from '@libs/translations';
import { DescriptionCard, Card } from '../organism';

export const Cards = ({ tagDescription, projects }) => {
  const translations = useTranslations();
  const description = {
    icon: getImage('icons/hello.png'),
    title: translations.t('site.galleryProjects.test.title'),
    text: translations.t('site.galleryProjects.test.text'),
  };

  return (
      <Container>
        {tagDescription &&
          <Description>
            <DescriptionCard icon={''}
                             title={tagDescription.title}
                             text={tagDescription.description}
                             isBigStyle={true}/>
          </Description>
        }

        <Wrapper>
          {!tagDescription &&
            <Item>
              <DescriptionCard icon={description.icon}
                               title={description.title}
                               text={description.text}/>
            </Item>
          }
          {projects.map((project) => (
            <Item key={project.id}>
              <Card project={project}/>
            </Item>
          ))}
        </Wrapper>
      </Container>
  );
};

const Container = styled.div`
  ${paddingLevel('top', 'azure')};
`;

const Description = styled.div`
  ${marginLevel('bottom', 'dark_cream')};
`;

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  
  @media ${Points.tablet_portrait} {
    margin: 0 -15px -30px;
  }
  
  @media ${Points.tablet_landscape} {
    margin: 0 -20px -40px;
  }
`;

const Item = styled.div`
  margin-bottom: 20px;
  width: 100%;

  @media ${Points.tablet_portrait} {
    ${Grid.column(1, 2)};
    padding: 0 15px;
    margin-bottom: 30px;
  } 
  
  @media ${Points.tablet_landscape} {
    ${Grid.column(1, 3)};
    padding: 0 20px;
    margin-bottom: 40px;
  }
`;
